import * as React from "react";
import type { SVGProps } from "react";
const SvgPrimaryCleanser = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 20 20"
    width="1em"
    height="1em"
    role="img"
    focusable={false}
    {...props}
  >
    <path
      stroke="#1D1D1D"
      strokeWidth={0.575}
      d="M7.412 16.325v1.785c0 .146.056.287.172.376.323.247 1.108.714 2.416.714 1.309 0 2.093-.467 2.416-.714a.46.46 0 0 0 .172-.376v-1.785m-5.176 0L5.758 1.438A.575.575 0 0 1 6.33.8h7.34c.343 0 .61.298.572.638l-1.654 14.887m-5.176 0s.934.863 2.588.863 2.588-.863 2.588-.863"
    />
  </svg>
);
export default SvgPrimaryCleanser;
